<div class="flex flex-column gap-3">
    <div *ngFor="let config of filterConfigs" class="flex flex-column gap-2">
        <label>{{ config.label }}</label>
        
        <!-- Select Button -->
        <p-selectButton 
            *ngIf="config.type === 'selectButton'" 
            [options]="config.options" 
            [(ngModel)]="filtres[config.key]" 
            optionLabel="label" 
            optionValue="value"
            (onChange)="onFilterChange()">
        </p-selectButton>
        
        <!-- Dropdown -->
        <p-dropdown 
            *ngIf="config.type === 'dropdown'" 
            [options]="config.options" 
            [(ngModel)]="filtres[config.key]" 
            optionLabel="label" 
            optionValue="value"
            placeholder="Sélectionner..."
            (onChange)="onFilterChange()">
        </p-dropdown>
        
        <!-- Checkbox -->
        <p-checkbox 
            *ngIf="config.type === 'checkbox'" 
            [(ngModel)]="filtres[config.key]" 
            [binary]="true"
            (onChange)="onFilterChange()">
        </p-checkbox>
        
        <!-- Input Text -->
        <input 
            *ngIf="config.type === 'input'" 
            type="text" 
            pInputText 
            [(ngModel)]="filtres[config.key]" 
            (input)="onFilterChange()"
            placeholder="{{ config.label }}">
    </div>
</div>